import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class HistoryDetailService {
  private _name: BehaviorSubject<any> = new BehaviorSubject<any>(null); // NOSONAR 
  name: Observable<any> = this._name.asObservable();

  private _shouldHide: BehaviorSubject<any> = new BehaviorSubject<any>(null); // NOSONAR 
  shouldHide: Observable<any> = this._shouldHide.asObservable();

  setName(object) {
    this._name.next(object);
    
  }

  setShouldHide(object){
    this._shouldHide.next(object);
    
  }

}
